import createComponent from './create-component';
import createStore from './create-store';
import createInstaller from './create-installer';

export default class LoadState {
    storeModuleName = 'loading';

    componentName = 'v-loading';

    storeInstance = null;

    installerInstance = null;

    /**
     * Gets the install factory for utility functions in the top scope of Vue
     * which can be used to return the store state for the custom module store.
     * @returns {Function}
     */
    get install() {
        if (this.installerInstance === null) {
            this.installerInstance = createInstaller({
                createComponent,
                componentName: this.componentName,
                storeModuleName: this.storeModuleName,
            });
        }
        return this.installerInstance;
    }

    /**
     * Gets the store factory for the current instance which will inject the
     * storeModuleName dynamically into the global store.
     * @returns {Function}
     */
    get store() {
        if (this.storeInstance === null) {
            this.storeInstance = createStore({storeModuleName: this.storeModuleName});
        }
        return this.storeInstance;
    }
}
